import { render, staticRenderFns } from "./TakeOrderOld.vue?vue&type=template&id=6071ad63&"
import script from "./TakeOrderOld.vue?vue&type=script&lang=js&"
export * from "./TakeOrderOld.vue?vue&type=script&lang=js&"
import style0 from "./TakeOrderOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports